document.addEventListener('DOMContentLoaded', function () {
  var _srLoaded = false;

  function initScrollReveal() {
    if (_srLoaded) return;
    _srLoaded = true;

    var s = document.createElement('script');
    s.src = 'https://unpkg.com/scrollreveal@4.0.0/dist/scrollreveal.min.js';
    s.onload = function () {
      window.sr = ScrollReveal({
        duration: 800,
        origin: 'bottom',
        distance: '25px',
        scale: 0.85,
      });
      sr.reveal('.product-card-wrapper', { interval: 100 });
      sr.reveal('.collection-card', { interval: 100 });
      sr.reveal('.article-card-wrapper', { interval: 100 });
      sr.reveal('.sr-animate--no-interval');
    };
    document.head.appendChild(s);
  }

  window.addEventListener('scroll', initScrollReveal, { once: true, passive: true });
  setTimeout(initScrollReveal, 500);
});
